import ObjectsByName from '../../generic/container/ObjectsByName';
import PolyMaps from './PolyMaps';
import PolyMap from './PolyMap';

export default function PolyMesh(from) {
  if (!from) {
    this.faceRangeOffsets = new Uint32Array(1);
    this.positions = new PolyMap();

    this.colorMaps = new ObjectsByName();
    this.uvMaps = new ObjectsByName();

  } else {

    if (!from.colorMaps) console.error('Polymesh must have initialized colorMaps container.');
    if (!from.uvMaps) console.error('Polymesh must have initialized uvMaps container.');

    this.faceRangeOffsets = from.faceRangeOffsets;               //Uint32Array
    this.positions = from.positions;                             //PolyMap Object
    this.normalMap = from.normalMap;                             //PolyMap Object
    this.uvMaps = ObjectsByName.shallowClone(from.uvMaps);       //ObjectsByName contains PolyMap Object

    //optional properties discarded topology change:
    if (from.skinning) this.skinning = from.skinning;                                //Skinning Object
    if (from.edgeCreaseWeights) this.edgeCreaseWeights = from.edgeCreaseWeights;     //Float32Array : index === edge, value === weight {0..1}
    if (from.materialIds) this.materialIds = from.materialIds;                       //Uint32Array  : index === face

    //not implemented:
    //this.tangentMap = from.tangentMap;                         //PolyMap Object
    this.colorMaps = ObjectsByName.shallowClone(from.colorMaps); //ObjectsByName contains PolyMap Object
  }
};

PolyMesh.prototype = {

  constructor: PolyMesh,

  getNumFaces: function () {

    return this.faceRangeOffsets.length - 1;

  },

  getNumFaceVertices: function () {

    return this.positions.faceValueIndices.length;

  },

  getNumVertices: function () {

    return this.positions.values.length;

  },

  getMapById: function (mapId) {

    return PolyMaps.resolveMap(this, mapId) || null;

  },

  topologyChanged: function () {
    //this function is only to be called during construction of a new polymesh
    //its purpose is to nullify data that would become invalidated due to a change in topology
    //the data to remain intact would have to also be correctly mapped in each operator
    //in the future operators will instead generate a mapping that can be applied through
    //a general mapping function so such additions can be done in a singular location
    if (this.skinning) this.skinning = null;
    if (this.edgeCreaseWeights) this.edgeCreaseWeights = null;
    if (this.materialIds) this.materialIds = null;
    return this;
  },

};

PolyMesh.fromData = function (
    faceRangeOffsets, positions, optionalIndices, optionalMaterialIds) {

  const polyMesh = new PolyMesh({
    faceRangeOffsets,
    positions: positions.isPolyMap ? positions :
        PolyMap.fromData(faceRangeOffsets, optionalIndices || null, positions),
    uvMaps: new ObjectsByName(),     // ObjectsByName< PolyMap<THREE.Vector2> >
    colorMaps: new ObjectsByName(),  // ObjectsByName< PolyMap<THREE.Color> >
  });

  if (optionalMaterialIds) polyMesh.materialIds = optionalMaterialIds;

  return polyMesh;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/model/PolyMesh.js